import React from 'react'
import * as S from './DropIcon.styled'

export default ({ up, icon, ...props }) => (
  <S.DropIcon up={up ? 1 : 0} icon={icon || 'chevronDown'} {...props} />
)
